export const PaymentIssueTemplate = {
    name: 'payment_issue',
    label: 'Payment issue',
    subject: "REBIT ${reference}: Payment issue!",
    category: 'compulsory',
    body: "<p>Hi ${payer_first_name},</p>"
        + "<p>Thanks, for your recent payment of ${paid_amount} ${origin_currency}! Unfortunately, we couldn't confirm the payer's Account Name. Bank account name must be ${payer_name}.</p>"
        + "<p><b>What's next?</b></p>"
        + "<p>To confirm payment was made from your own account please send us one of the following at your earliest convenience.</p>"
        + "<ul>"
        + "<li>Proof of Account showing your Name, Address and Account Number</li>"
        + "<li>A bank statement showing your recent transaction of ${paid_amount} ${origin_currency}.</li>"
        + "</ul>"
        + "<p><b>What if I paid from someone else's account or my business?</b></p>"
        + "<ul>"
        + "<li>Reply to <b>kyc@rebit.co.nz</b> and let us know the account number and the payer's name.</li>"
        + "<li>On your Internet Banking go to Documents, download a statement as pdf and attach it to your reply. It must show the recent transaction of ${paid_amount} ${origin_currency}. Screenshots of mobile banking are NOT accepted.</li>"
        + "<li>We may process a refund to the payer's bank account, and you can process your order once it is paid from your own account.</li>"
        + "</ul>"
        + "<p>⚠️ Just a friendly reminder: According to Anti-Money-Laundering regulations, your Rebit profile name should match the payer's bank account name.</p>"
        + "<p>If you have any questions or concerns, please contact our Compliance team via <a href='mailto:kyc@rebit.co.nz'>kyc@rebit.co.nz</a></p>"
}

